const getRibModeDescription = (input, value) => {
  switch (input) {
    case "single":
      return "Single Color Ribs - " + value;
    case "no":
      return "No Ribs";
    case "multiple":
      return "Multiple Color Ribs";
    default:
      "";
  }
};

const getSealantModeDescription = (input) => {
  switch (input.mode) {
    case "no":
      return "No sealant";
    case "sealant":
      return "Waterproof Sealant";
    default:
      "";
  }
};
const getFoamDescription = (input) => {
  // console.log("getFoamDescription input:", input);
  switch (input) {
    case "foam":
      return "Cover + Foam";
    default:
      return "Seat Cover Only";
  }
};

const getRaceNumberDescription = (value) => {
  if (value.mode === "none") {
    return "None";
  } else {
    return value.number + " / " + value.name;
  }
};
const getSuperBadgeDescription = (value) => {
  // console.log(value)
  if (value.mode === "none") {
    return "None";
  } else {
    return value.subMode;
  }
};
const getSidesDescription = (value) => {
  if (value.mode === "reinforced") {
    return "Reinforced " + value.name;
  } else {
    return value.name;
  }
};
const getSideLogoDescription = (value) => {
  if (value === "None") {
    return "None";
  } else {
    return value;
  }
};

export {
  getRibModeDescription,
  getSuperBadgeDescription,
  getSealantModeDescription,
  getRaceNumberDescription,
  getSidesDescription,
  getSideLogoDescription,
  getFoamDescription,
};
